/**
 * Detects if a buffer contains text data by checking for binary indicators
 * and verifying that most characters are printable.
 *
 * @param buffer - The file buffer to analyze
 * @returns true if the buffer appears to contain text data, false otherwise
 */
export function isTextFile(buffer) {
    if (buffer.length === 0) {
        return true;
    }
    const sample = buffer.slice(0, Math.min(8192, buffer.length));
    if (sample.includes(0)) {
        return false;
    }
    try {
        const text = sample.toString("utf-8");
        if (text.includes("\uFFFD")) {
            return false;
        }
        let printable = 0;
        let total = 0;
        for (const char of text) {
            const code = char.charCodeAt(0);
            total++;
            if ((code >= 32 && code <= 126) || code === 9 || code === 10 || code === 13 || code > 127) {
                printable++;
            }
        }
        return printable / total >= 0.95;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=isTextFile.js.map